import { defineMessages } from 'react-intl';

const messages = defineMessages({
  commonSettings: {
    id: 'app.components.RouteForm.commonSettings',
    defaultMessage: 'Common Settings',
  },
  name: {
    id: 'app.components.RouteForm.name',
    defaultMessage: 'Name',
  },
  meetingPlace: {
    id: 'app.components.RouteForm.meetingPlace',
    defaultMessage: 'Meeting Place',
  },
  minPublishers: {
    id: 'app.components.RouteForm.minPublishers',
    defaultMessage: 'Minimum Publishers',
  },
  maxPublishers: {
    id: 'app.components.RouteForm.maxPublishers',
    defaultMessage: 'Maximum Publishers',
  },
  brotherRequirement: {
    id: 'app.components.RouteForm.brotherRequirement',
    defaultMessage: 'Brother requirement',
  },
  brotherRequirementDescription: {
    id: 'app.components.RouteForm.brotherRequirementDescription',
    defaultMessage:
      'Set how many brothers a team needs as it grows. The first band starts at one participant; add a band wherever the requirement should increase.',
  },
  brotherRequirementFromFirstParticipant: {
    id: 'app.components.RouteForm.brotherRequirementFromFirstParticipant',
    defaultMessage: 'From 1 participant',
  },
  brotherRequirementFromParticipants: {
    id: 'app.components.RouteForm.brotherRequirementFromParticipants',
    defaultMessage: 'From participants',
  },
  brotherRequirementBrothers: {
    id: 'app.components.RouteForm.brotherRequirementBrothers',
    defaultMessage: 'Brothers',
  },
  brotherRequirementAddBand: {
    id: 'app.components.RouteForm.brotherRequirementAddBand',
    defaultMessage: 'Add band',
  },
  brotherRequirementRemoveBand: {
    id: 'app.components.RouteForm.brotherRequirementRemoveBand',
    defaultMessage: 'Remove band',
  },
  brotherRequirementFirstBandMustStartAtOne: {
    id: 'app.components.RouteForm.brotherRequirementFirstBandMustStartAtOne',
    defaultMessage: 'The first band must start at one participant',
  },
  brotherRequirementThresholdsMustIncrease: {
    id: 'app.components.RouteForm.brotherRequirementThresholdsMustIncrease',
    defaultMessage:
      'Each band must start at more participants than the one before',
  },
  brotherRequirementBrotherCountsMustIncrease: {
    id: 'app.components.RouteForm.brotherRequirementBrotherCountsMustIncrease',
    defaultMessage: 'Each band must require more brothers than the one before',
  },
  brotherRequirementCountsMustBePositive: {
    id: 'app.components.RouteForm.brotherRequirementCountsMustBePositive',
    defaultMessage: 'Participants and brothers must be greater than zero',
  },
  minPublishersMustBeGreaterThanZero: {
    id: 'app.components.RouteForm.minPublishersMustBeGreaterThanZero',
    defaultMessage: 'Minimum publishers must be greater than zero',
  },
  maxPublishersMustBeGreaterThanZero: {
    id: 'app.components.RouteForm.maxPublishersMustBeGreaterThanZero',
    defaultMessage: 'Maximum publishers must be greater than zero',
  },
  maxPublishersMustBeGreaterThanMinPublishers: {
    id: 'app.components.RouteForm.maxPublishersMustBeGreaterThanMinPublishers',
    defaultMessage:
      'Maximum publishers must be greater than minimum publishers',
  },
  depot: {
    id: 'app.components.RouteForm.depot',
    defaultMessage: 'Depot',
  },
  settingsForAutomatedPlanning: {
    id: 'app.components.RouteForm.settingsForAutomatedPlanning',
    defaultMessage: 'Settings for Automated Planning',
  },
  evenNumberOfParticipants: {
    id: 'app.components.RouteForm.evenNumberOfParticipants',
    defaultMessage: 'Even Number of Participants',
  },
  keepRouteStaffed: {
    id: 'app.components.RouteForm.keepRouteStaffed',
    defaultMessage: 'Keep Route Staffed',
  },
  keepRouteStaffedDescription: {
    id: 'app.components.RouteForm.keepRouteStaffedDescription',
    defaultMessage:
      'When enabled, the system will try to keep this route staffed at all times',
  },
  assignmentRangeFirstShift: {
    id: 'app.components.RouteForm.assignmentRangeFirstShift',
    defaultMessage: 'Assignment Range First Shift',
  },
  assignmentRangeLastShift: {
    id: 'app.components.RouteForm.assignmentRangeLastShift',
    defaultMessage: 'Assignment Range Last Shift',
  },
  enableAssignmentRangeFirstShift: {
    id: 'app.components.RouteForm.enableAssignmentRangeFirstShift',
    defaultMessage: 'Enable Assignment Range First Shift',
  },
  enableAssignmentRangeLastShift: {
    id: 'app.components.RouteForm.enableAssignmentRangeLastShift',
    defaultMessage: 'Enable Assignment Range Last Shift',
  },
});

export default messages;
